<template>
  <v-container
    fill-height
    fluid
    grid-list-xl>
    <v-layout
      justify-center
      wrap>
      <v-flex md12>
        <div>
          <material-card
            color="primary"
            title="Users Table">
            <v-spacer />
            <v-text-field
              v-model="search"
              append-icon="search"
              label="Search"
              single-line
              hide-details
            />
            <v-dialog
              v-model="dialogBlock"
              max-width="500px">
              <v-card>
                <v-card-title
                  class="headline"
                >Are you sure you want to block this user?</v-card-title
                >
                <v-card-actions>
                  <v-spacer/>
                  <v-btn
                    color="blue darken-1"
                    text
                    @click="closeBlock"
                  >Cancel</v-btn
                  >
                  <v-btn
                    color="green darken-1"
                    text
                    @click="blockItemConfirm"
                  >OK</v-btn
                  >
                  <v-spacer/>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <v-dialog
              v-model="dialogUnblock"
              max-width="500px">
              <v-card>
                <v-card-title
                  class="headline"
                >Are you sure you want to unblock this user?</v-card-title
                >
                <v-card-actions>
                  <v-spacer/>
                  <v-btn
                    color="blue darken-1"
                    text
                    @click="closeUnblock"
                  >Cancel</v-btn
                  >
                  <v-btn
                    color="green darken-1"
                    text
                    @click="unBlockItemConfirm"
                  >OK</v-btn
                  >
                  <v-spacer/>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <v-dialog
              v-model="dialogDelete"
              max-width="500px">
              <v-card>
                <v-card-title
                  class="headline"
                >Are you sure you want to delete this user?</v-card-title
                >
                <v-card-actions>
                  <v-spacer/>
                  <v-btn
                    color="blue darken-1"
                    text
                    @click="closeDelete"
                  >Cancel</v-btn
                  >
                  <v-btn
                    color="green darken-1"
                    text
                    @click="deleteItemConfirm"
                  >OK</v-btn
                  >
                  <v-spacer/>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <v-dialog
              v-model="dialogEdit"
              max-width="800px">
              <v-card>
                <v-card-text>
                  <v-container grid-list-md>
                    <v-layout wrap>
                      <v-flex
                        xs12
                        sm6
                        md4>
                        <v-text-field
                          v-model="editedItem.firstname"
                          label="First Name"
                        />
                      </v-flex>
                      <v-flex
                        xs12
                        sm6
                        md4>
                        <v-text-field
                          v-model="editedItem.lastname"
                          label="Last Name"
                        />
                      </v-flex>
                      <v-flex
                        xs12
                        sm6
                        md4>
                        <v-text-field
                          v-model="editedItem.email"
                          disabled
                          label="Email"
                        />
                      </v-flex>
                      <v-flex
                        xs12
                        sm6
                        md4>
                        <v-text-field
                          v-model="editedItem.phone"
                          label="Phone"
                        />
                      </v-flex>
                      <v-flex
                        xs12
                        sm6
                        md4>
                        <v-text-field
                          v-model="editedItem.afm"
                          label="ΑΦΜ" />
                      </v-flex>
                      <!-- <v-flex
                        xs12
                        sm6
                        md4>
                        <v-text-field
                          v-model="editedItem.address"
                          label="Address"
                        />
                      </v-flex> -->
                      <!-- <v-flex
                        xs12
                        sm6
                        md4>
                        <v-text-field
                          v-model="editedItem.supply_number"
                          label="Supply Number"
                        />
                      </v-flex> -->
                      <!-- <v-flex
                        xs12
                        sm6
                        md4>
                        <v-text-field
                          v-model="editedItem.kwh_price"
                          label="kWh Price"
                          @keypress="isNumber()"
                        />
                      </v-flex> -->
                      <!-- <v-flex xs12 sm6 md4>
                        <v-checkbox
                          dense
                         v-model="checkbox"
                        label="Assign this user to a project"
                        ></v-checkbox>
                      </v-flex> -->
                      <!-- <v-flex xs12 sm6 md4>
                        <v-autocomplete
                          dense
                          v-model="editedItem.project"
                          :items="projects"
                          label="Project (Optional)"
                        ></v-autocomplete>
                      </v-flex> -->
                      <!-- <v-row align="center">
                        <v-checkbox
                          v-model="enabled"
                          hide-details
                          class="shrink mr-2 mt-0"
                        ></v-checkbox>
                        <v-text-field
                          :disabled="!enabled"
                          label="I only work if you check the box"
                        ></v-text-field>
                      </v-row> -->
                      <v-flex
                        xs12
                        sm6
                        md8>
                        <v-checkbox
                          v-model="project_checkbox"
                          hide-details
                          label="Assign this user to a project"
                          class="shrink mr-2 mt-0"
                        />
                        <v-autocomplete
                          v-model="editedItem.project"
                          :disabled="!project_checkbox"
                          :items="projects"
                          dense
                          label="Project"
                        />
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>

                <v-card-actions>
                  <v-spacer />
                  <v-btn
                    color="blue darken-1"
                    @click="closeEdit">Cancel</v-btn>
                  <v-btn
                    color="green darken-1"
                    @click="editUser">Save</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <v-data-table
              :headers="headers"
              :items="UserList"
              :rows-per-page-items="rowsAmount"
              :search="search"
              class="users-table"
              hide-actions
            >
              <!-- change table header background and text color(or other properties) -->
              <template
                slot="headerCell"
                slot-scope="{ header }">
                <span
                  class="subheading font-weight-light text-general text--darken-3"
                  v-text="header.text"
                />
              </template>
              <template v-slot:items="props">
                <td class="">
                  {{
                    props.item.firstname !== null && props.item.firstname !== ""
                      ? props.item.firstname
                      : "-"
                  }}
                </td>
                <td class="">
                  {{
                    props.item.lastname !== null && props.item.lastname !== ""
                      ? props.item.lastname
                      : "-"
                  }}
                </td>
                <td class="">
                  {{
                    props.item.email !== null && props.item.email !== ""
                      ? props.item.email
                      : "-"
                  }}
                </td>
                <td class="">
                  {{
                    props.item.phone !== null && props.item.phone !== ""
                      ? props.item.phone
                      : "-"
                  }}
                </td>
                <td class="">
                  {{
                    props.item.afm !== null && props.item.afm !== ""
                      ? props.item.afm
                      : "-"
                  }}
                </td>
                <td class="">
                  {{ formatRoles(props.item.role, props.item.project) }}
                </td>
                <td class="">
                  {{
                    props.item.project !== null && props.item.project !== ""
                      ? props.item.project
                      : "-"
                  }}
                </td>
                <td class="">
                  {{
                    props.item.address !== null && props.item.address !== ""
                      ? props.item.address
                      : "-"
                  }}
                </td>
                <!--
                <td class="">
                  {{
                    props.item.supply_number !== null &&
                      props.item.supply_number !== ""
                      ? props.item.supply_number
                      : "-"
                  }}
                </td>
                <td class="">
                  {{
                    props.item.kwh_price !== null && props.item.kwh_price !== ""
                      ? props.item.kwh_price
                      : "-"
                  }}
                </td> -->
                <td class="">
                  {{
                    props.item.accepted_terms_on !== null &&
                      props.item.accepted_terms_on !== ""
                      ? formatDate(props.item.accepted_terms_on)
                      : "-"
                  }}
                </td>
                <td class="">
                  {{ props.item.is_disabled ? "YES" : "NO" }}
                </td>
                <td class="justify-center ">
                  <v-icon
                    medium
                    class="mr-2"
                    @click="editItem(props.item)"
                  >edit</v-icon
                  >
                  <v-icon
                    medium
                    @click="deleteItem(props.item)">delete</v-icon>
                  <v-icon
                    medium
                    @click="
                      props.item.is_disabled
                        ? unBlockItem(props.item)
                        : blockItem(props.item)
                    "
                  >lock</v-icon
                  >
                </td>
              </template>
            </v-data-table>
            <v-snackbar
              v-model="snack"
              :timeout="3000"
              :color="snackColor">
              {{ snackText }}
              <v-btn
                flat
                @click="snack = false">Close</v-btn>
            </v-snackbar>
          </material-card>
        </div>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import moment from 'moment'

export default {
  data: () => ({
    snack: false,
    snackColor: '',
    snackText: '',
    UserList: [],
    UnapprovedUsersList: [],
    rowsAmount: [
      10,
      15,
      20,
      { text: '$vuetify.dataIterator.rowsPerPageAll', value: -1 }
    ],
    dialogBlock: false,
    dialogUnblock: false,
    dialogEdit: false,
    dialogDelete: false,
    dialogApprove: false,
    search: '',
    searchUnapproved: '',
    headers: [
      { text: 'Id', value: 'id', align: ' d-none' },
      { text: 'First Name', value: 'firstname' },
      { text: 'Last Name', value: 'lastname' },
      { text: 'Email', value: 'email' },
      { text: 'Phone', value: 'phone' },
      { text: 'ΑΦΜ', value: 'afm' },
      { text: 'Role', value: 'role' },
      { text: 'Project', value: 'project' },
      { text: 'User Address', value: 'address' },
      // { text: 'Supply Number', value: 'supply_number' },
      // { text: 'kWh Price', value: 'kwh_price' },
      { text: 'Accepted Terms on', value: 'accepted_terms_on' },
      { text: 'Locked', value: 'is_disabled' },
      { text: 'Actions', value: 'actions', sortable: false }
    ],
    blockedIndex: -1,
    blockedItem: {},
    unBlockedIndex: -1,
    unBlockedItem: {},
    approvedIndex: -1,
    approvedItem: {},
    deletedIndex: -1,
    deletedItem: {},
    editedIndex: -1,
    editedItem: {
      id: '',
      firstname: '',
      lastname: '',
      email: '',
      phone: '',
      afm: '',
      address: '',
      supply_number: '',
      kwh_price: '',
      project: ''
    },
    defaultItem: {},
    projects: [],
    project_checkbox: false
  }),

  watch: {
    dialogBlock (val) {
      val || this.closeBlock()
    },
    dialogUnblock (val) {
      val || this.closeUnblock()
    },
    dialogEdit (val) {
      val || this.closeEdit()
    },
    dialogDelete (val) {
      val || this.closeDelete()
    },
    dialogApprove (val) {
      val || this.closeApprove()
    }
  },
  // called when page is created before dom
  created () {
    this.getUsers()
    this.getProjects()
  },

  methods: {
    formatDate (dateTime) {
      return moment(dateTime).format('MMM DD, YYYY HH:mm:ss')
    },
    getUsers () {
      this.$http
        .get('admin/users')
        .then((response) => {
          this.UserList = response.data
          localStorage.setItem('token', response.headers.token)
        })
        .catch((error) => console.log(error))
    },

    getProjects () {
      this.$http
        .get('projects')
        .then((response) => {
          var obj = response.data.projects
          this.projects = []
          for (var i = 0; i < obj.length; i++) {
            this.projects.push(obj[i].project)
          }
        })
        .catch((error) => console.log(error))
    },

    formatRoles (role_id, project) {
      if (role_id == 2) {
        return 'Admin'
      } else {
        if (project !== null && project != '') {
          return 'Project User'
        } else {
          return 'End User'
        }
      }
    },

    // formatProjects(project) {
    //   if (project !== null && project !== "") {
    //     return project;
    //   } else {
    //     return "-";
    //   }
    // },

    isNumber (evt) {
      evt = evt || window.event
      let charCode = evt.which || evt.keyCode
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault()
      } else {
        return true
      }
      return false
    },

    validateEmail (inputText) {
      var mailformat = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/
      if (inputText.match(mailformat)) {
        return true
      } else {
        return false
      }
    },

    // APPROVE USER

    approveItem (item) {
      this.approvedIndex = this.UnapprovedUsersList.indexOf(item)
      this.approvedItem = Object.assign({}, item)
      this.dialogApprove = true
    },

    approveItemConfirm () {
      let endpoint = `user/${this.approvedItem.id}/approve`
      let method = 'patch'
      let tableItem = this.approvedItem
      this.$store
        .dispatch('approveUser', { endpoint, tableItem, method })
        .then((response) => {
          this.saveInline()
          this.getUsers()
          this.getUnapprovedUsers()
        })
        .catch((error) => {
          console.log(error)
          this.apiErrorInline()
        })

      this.closeApprove()
    },

    closeApprove () {
      this.dialogApprove = false
      this.$nextTick(() => {
        this.approvedItem = Object.assign({}, this.defaultItem)
        this.approvedItem = -1
      })
    },

    // BLOCK USER

    blockItem (item) {
      this.blockedIndex = this.UserList.indexOf(item)
      this.blockedItem = Object.assign({}, item)
      this.dialogBlock = true
    },

    blockItemConfirm () {
      let objectForEditUser = {}
      objectForEditUser.is_disabled = true
      let endpoint = `user/${this.blockedItem.id}`
      let method = 'patch'
      let tableItem = objectForEditUser
      this.$store
        .dispatch('editUser', { endpoint, tableItem, method })
        .then((response) => {
          this.saveInline()
          this.getUsers()
        })
        .catch((error) => {
          console.log(error)
          this.apiErrorInline()
        })

      this.closeBlock()
    },

    closeBlock () {
      this.dialogBlock = false
      this.$nextTick(() => {
        this.blockedItem = Object.assign({}, this.defaultItem)
        this.blockedItem = -1
      })
    },

    // UNBLOCK USER

    unBlockItem (item) {
      this.unBlockedIndex = this.UserList.indexOf(item)
      this.unBlockedItem = Object.assign({}, item)
      this.dialogUnblock = true
    },

    unBlockItemConfirm () {
      let objectForEditUser = {}
      objectForEditUser.is_disabled = false
      let endpoint = `user/${this.unBlockedItem.id}`
      let method = 'patch'
      let tableItem = objectForEditUser
      this.$store
        .dispatch('editUser', { endpoint, tableItem, method })
        .then((response) => {
          this.saveInline()
          this.getUsers()
        })
        .catch((error) => {
          console.log(error)
          this.apiErrorInline()
        })

      this.closeUnblock()
    },

    closeUnblock () {
      this.dialogUnblock = false
      this.$nextTick(() => {
        this.unBlockedItem = Object.assign({}, this.defaultItem)
        this.unBlockedItem = -1
      })
    },

    // EDIT USER

    editItem (item) {
      this.editedIndex = this.UserList.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.project_checkbox =
        !!(this.editedItem.project !== null &&
        this.editedItem.project !== undefined &&
        this.editedItem.project !== '')
      this.dialogEdit = true
    },

    closeEdit () {
      this.dialogEdit = false
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedItem = -1
      })
    },

    editUser () {
      // if (
      //   // this.editedItem.firstname == "" ||
      //   // this.editedItem.firstname == undefined ||
      //   // this.editedItem.lastname == "" ||
      //   // this.editedItem.lastname == undefined ||
      //   this.editedItem.email == "" ||
      //   this.editedItem.email == undefined
      // ) {
      //   this.requiredInline();
      // }
      if (
        this.editedItem.email !== '' &&
        this.editedItem.email !== undefined &&
        !this.validateEmail(this.editedItem.email)
      ) {
        this.emailErrorInline()
      } else {
        let objectForEditUser = {}
        objectForEditUser.firstname = this.editedItem.firstname
        objectForEditUser.lastname = this.editedItem.lastname
        objectForEditUser.email = this.editedItem.email
        objectForEditUser.phone = this.editedItem.phone
        objectForEditUser.afm = this.editedItem.afm

        objectForEditUser.address =
          this.editedItem.address !== undefined ? this.editedItem.address : ''

        objectForEditUser.supply_number =
          this.editedItem.supply_number !== undefined
            ? this.editedItem.supply_number
            : ''

        objectForEditUser.kwh_price =
          this.editedItem.kwh_price !== undefined &&
          this.editedItem.kwh_price !== ''
            ? this.editedItem.kwh_price
            : null

        if (this.project_checkbox) {
          if (
            this.editedItem.project !== null &&
            this.editedItem.project !== undefined &&
            this.editedItem.project !== ''
          ) {
            objectForEditUser.project = this.editedItem.project
          } else {
            objectForEditUser.project = null
          }
        } else {
          objectForEditUser.project = null
        }

        let endpoint = `user/${this.editedItem.id}`
        let method = 'patch'
        let tableItem = objectForEditUser
        this.$store
          .dispatch('editUser', { endpoint, tableItem, method })
          .then((response) => {
            this.saveInline()
            this.getUsers()
          })
          .catch((error) => {
            console.log(error)
            this.apiErrorInline()
          })

        this.closeEdit()
      }
    },

    // DELETE USER

    deleteItem (item) {
      this.deletedIndex = this.UserList.indexOf(item)
      this.deletedItem = Object.assign({}, item)
      this.dialogDelete = true
    },

    deleteItemConfirm () {
      let endpoint = `user/${this.deletedItem.id}`
      let method = 'delete'
      let tableItem = this.deletedItem
      this.$store
        .dispatch('deleteUser', { endpoint, tableItem, method })
        .then((response) => {
          this.UserList.splice(this.deletedIndex, 1)
          this.saveInline()
        })
        .catch((error) => {
          console.log(error)
          this.apiErrorInline()
        })

      this.closeDelete()
    },

    closeDelete () {
      this.dialogDelete = false
      this.$nextTick(() => {
        this.deletedItem = Object.assign({}, this.defaultItem)
        this.deletedItem = -1
      })
    },

    // toasts/snackbar messages for actions
    saveInline () {
      this.snack = true
      this.snackColor = 'heron_success'
      this.snackText = 'Success!'
    },
    requiredInline () {
      this.snack = true
      this.snackColor = 'error'
      this.snackText = 'Fill all required fields'
    },
    cancelInline () {
      this.snack = true
      this.snackColor = 'error'
      this.snackText = 'Canceled'
    },
    emailErrorInline () {
      this.snack = true
      this.snackColor = 'error'
      this.snackText = 'Enter a valid Email'
    },
    reset () {
      this.snack = true
      this.snackColor = 'heron_success'
      this.snackText = 'Data reset to default'
    },
    openInline () {
      this.snack = true
      this.snackColor = 'heron_info'
      this.snackText = 'Dialog opened'
    },
    apiErrorInline () {
      this.snack = true
      this.snackColor = 'error'
      this.snackText = 'Something went wrong'
    },
    closeInline () {
      console.log('Dialog closed')
    }
  }
}
</script>

<style>
table.v-table thead tr {
  color: red !important;
}
tbody tr:nth-of-type(odd) {
  background-color: rgba(0, 0, 0, 0.05);
}
.users-table {
  max-height: 80vh;
  overflow-y: auto;
}
/* #table > .v-data-footer .v-icon {
  color: black;
} */
</style>
